import React, { useContext, useRef, useState } from 'react';
import { Popover, Input } from 'antd';
import Context from './context';
import { RICH_TYPE } from './configs';
import { filterXSS } from 'xss';

import {
  RichUtils,
  CompositeDecorator,
  SelectionState,
  EditorState,
} from 'draft-js';

const { TextArea } = Input;

export const PopoverLinkWrapper = (props) => (
  <div className="lifecycle-link-input-wrapper">
    <span className="appkiticon icon-link-outline" />
    {props.children}
  </div>
);

export const DECORATOR_TYPE = {
  LINK: RICH_TYPE.LINK,
};

const IconButton = (props) => (
  <div className="icon-btn" onClick={props.onClick}>
    {props.children}
  </div>
);

const renderBtns = ({
  isEditing,
  handleEdit,
  handleRemove,
  handleCancel,
  handleSave,
} = {}) => {
  if (isEditing) {
    return (
      <>
        <IconButton onClick={handleCancel}>
          <span className="appkiticon icon-close-fill" />
        </IconButton>
        <IconButton onClick={handleSave}>
          <span className="appkiticon icon-check-mark-fill" />
        </IconButton>
      </>
    );
  }
  return (
    <>
      <IconButton onClick={handleEdit}>
        <span className="appkiticon icon-pencil-fill" />
      </IconButton>
      <IconButton onClick={handleRemove}>
        <span className="appkiticon icon-delete-fill" />
      </IconButton>
    </>
  );
};

const getLink = (url) =>
  url.trim().indexOf('http://') === 0 || url.trim().indexOf('https://') === 0
    ? url
    : `http://${url}`;

/************** componnets *************/
const Link = ({ contentState, entityKey, children, start, end, blockKey }) => {
  const [isEditing, toggleEditing] = useState(false);
  const currentEntity = contentState.getEntity(entityKey);
  const { url } = currentEntity.getData();

  const inputRef = useRef(null);

  const {
    stateSetter,
    readonlySetter,
    handleEditLink,
    displayMode,
    linkPopoverProps = {},
  } = useContext(Context);

  const handleRemove = () => {
    const selection = SelectionState.createEmpty(blockKey).merge({
      anchorOffset: start,
      focusOffset: end,
    });
    readonlySetter(false);
    stateSetter((currentState) =>
      EditorState.moveSelectionToEnd(
        RichUtils.toggleLink(currentState, selection, null),
      ),
    );
  };

  const handleEdit = () => {
    readonlySetter(true);

    toggleEditing(true);
  };

  const handleCancel = () => {
    toggleEditing(false);
    readonlySetter(false);
  };

  const handleSave = () => {
    const newlink = inputRef.current?.resizableTextArea?.textArea?.value;

    if (!newlink) {
      return handleRemove();
    }

    handleEditLink(entityKey, newlink);
    handleCancel();
  };

  const handlePopoverVisibleChange = (visible) => {
    if (!visible) {
      handleCancel();
    }
  };

  return (
    <Popover
      // trigger={displayMode ? 'none' : 'hover'}
      onVisibleChange={handlePopoverVisibleChange}
      overlayClassName="lifecycle-link-popover"
      getPopupContainer={() =>
        document.body ||
        document.getElementsByClassName('lifecycle-phases-container')[0]
      }
      {...linkPopoverProps}
      mouseLeaveDelay={0.6}
      content={
        <PopoverLinkWrapper>
          {isEditing ? (
            <TextArea ref={inputRef} autoFocus defaultValue={url} autoSize />
          ) : (
            <span className="url">{url}</span>
          )}
          {!displayMode &&
            renderBtns({
              handleCancel,
              handleRemove,
              handleSave,
              handleEdit,
              isEditing,
            })}
        </PopoverLinkWrapper>
      }
    >
      <a
        className="lifecycle-link"
        href={filterXSS(getLink(url))}
        target="_blank"
        rel="noreferrer"
      >
        {children}
      </a>
    </Popover>
  );
};

function findLinkEntities(contentBlock, cb, contentState) {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === DECORATOR_TYPE.LINK
    );
  }, cb);
}

export default new CompositeDecorator([
  {
    strategy: findLinkEntities,
    component: Link,
  },
]);
